module.exports = ".close-button {\n  position: absolute;\n  top: 0;\n  right: 0;\n  cursor: pointer; }\n\n.content {\n  position: relative; }\n"